<template>
  <a
    :class="$style.externalLink"
    :href="href"
    :rel="rel"
    :target="target"
    @click="handleClick"
  >
    {{ text }}
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 8" v-if="showExternalLinkIcon" :class="$style.linkIcon" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.78 6.595a.667.667 0 00.672-.66l.043-4.757a.667.667 0 00-.673-.673L2.066.548a.667.667 0 00.012 1.333l3.126-.028L.7 6.357a.667.667 0 00.943.943l4.504-4.504-.028 3.126a.667.667 0 00.66.673z" fill="#176FAC"/></svg>
  </a>
</template>

<script>
export default {
  name: 'ExternalLink',

  props: {
    href: {
      required: true,
      type: String,
    },
    rel: {
      type: String,
      default: 'noopener noreferrer',
    },
    showExternalLinkIcon: {
      type: Boolean,
      default: true,
    },
    target: {
      type: String,
      default: '_blank',
    },
    text: {
      required: true,
      type: String,
    },
  },

  methods: {
    handleClick() {
      this.$emit('click');
    },
  },
};
</script>

<style module>
.linkIcon {
  height: 8px;
  margin-left: 5px;
}

.externalLink {
  border-bottom: 1px solid transparent;
}

.externalLink:hover,
.externalLink:focus {
  border-bottom-color: currentColor;
  text-decoration: none !important;
}
</style>
